import { openBlock, createElementBlock, Fragment, createElementVNode, mergeProps, renderSlot, createCommentVNode } from "vue";
/* empty css            */
import _export_sfc from "../../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = {
  key: 0,
  class: "separator"
};
const _sfc_main = {
  __name: "Row",
  props: {
    oneColumn: {
      type: Boolean,
      default: false
    },
    separator: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createElementVNode("div", mergeProps({ class: "row" }, _ctx.$attrs, {
          class: { "one-column": __props.oneColumn }
        }), [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ], 16),
        __props.separator ? (openBlock(), createElementBlock("div", _hoisted_1)) : createCommentVNode("", true)
      ], 64);
    };
  }
};
const Row = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-4472f1dc"]]);
export {
  Row as default
};
//# sourceMappingURL=Row.vue.es.js.map
